import { makeTranslationHelpers } from './makeTranslationHelpers';

export const { useTranslation, Translation } = makeTranslationHelpers('web');
